import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { B02UserManagementPage } from '../b02-user-management/b02-user-management';
import { ServiceApiProvider } from '../../providers/service-api/service-api';

/**
 * Generated class for the B02aUserAddPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-b02a-company-add',
  templateUrl: 'b02a-company-add.html',
})
export class B02aCompanyAddPage {
  private todo : FormGroup;
  loading: any;
  Status: any;
  public errorMessage: any = "";

  branchData = {BRANCH_NAME:'',
                ADDR1:'', ADDR2:'', ADDR3:'',
                CONTACT_NO: '', EMAIL:'', PIC:'',
                BRANCH_ACTIVE:'YES',   
  }

  constructor(public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, public serviceapi: ServiceApiProvider,
              private toastCtrl: ToastController, public loadingCtrl: LoadingController) {

    this.todo = this.formBuilder.group({
      name: ['', Validators.required],
      address: ['', Validators.required],
      postCode: ['', Validators.required],
      state: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', Validators.required],
      pic: ['', Validators.required],
      active: ['', Validators.required],
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B02aCompanyAddPage');
  }

  save(){
    this.showLoader();

    this.serviceapi.insertdata("BRANCH",this.branchData).then((result) => {
        this.Status = result["Message"];

        if (this.Status == "1"){
          this.loading.dismiss();
          this.navCtrl.setRoot(B02UserManagementPage);
        }
        else{
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
          this.loading.dismiss();
        }
      }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
      });
  }

  goToUser(){
    this.navCtrl.pop();
  }

  goTo(){
    this.navCtrl.setRoot(B02UserManagementPage);
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        dismissOnPageChange: true,
        duration: 5000
    });
    this.loading.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/b02a-company-add/b02a-company-add.ts